module.exports = __webpack_public_path__ + "img/diamond_level3.cffb5613.png";